module.exports = __webpack_public_path__ + "static/media/email-logo.8a1834f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Contact/contact-images/email-logo.png
// module id = 264
// module chunks = 0